import firebase from "firebase/app";
import  "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/functions";

 
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAU2a9_N1EAz96o53xFakAN9VykClRBPC4",
    authDomain: "ice-fishing-derby.firebaseapp.com",
    projectId: "ice-fishing-derby",
    storageBucket: "ice-fishing-derby.appspot.com",
    messagingSenderId: "364903247850",
    appId: "1:364903247850:web:6bda3a1c7cf28fc00e8c93",
    measurementId: "G-810FJ3EP4R"
  };

  const application = firebase.initializeApp(firebaseConfig);
  export const  auth = application.auth();  
  export const googleprovider = new firebase.auth.GoogleAuthProvider();
  export const appleprovider = new firebase.auth.OAuthProvider('apple.com');
  export var db = application.firestore();
  export const storage = application.storage();
  export const functions =  firebase.functions();
  
  export default application;